const checkBoxFontSize = 12;
const fieldFontSize = 14;

export const styles = ({ palette }) => ({
  paperWidthMd: {
    width: '40%',
    overflow: 'visible',
    backgroundColor: palette.white,
  },
  backgroundStyle: {
    backgroundColor: palette.white,
  },
  scrollPaperTablet: {
    alignItems: 'baseline',
  },
  panel: {
    padding: '10px 20px 10px 20px',
    background: palette.white,
    overflow: 'visible',
  },
  textField: {
    '& label.Mui-focused': {
      color: palette.black,
    },
    '& label': {
      color: palette.black,
    },

    '& input': {
      fontSize: fieldFontSize,
      paddingBottom: 4,
      '&::placeholder': {
        color: palette.black,
        opacity: '100%',
      },
    },
  },
  clrSection: {
    display: 'flex',
    alignItems: 'center',
    border: 'none',
    paddingTop: 12,
    backgroundColor: palette.white,
    color: palette.black,
    fontSize: '13px',
    borderRadius: 0,
  },
  editSection: {
    background: palette.white,
    color: palette.black,
    fontSize: '13px',
    height: 56,
    width: '100%',
    borderBottomStyle: 'solid',
    borderRadius: 0,
    borderBottomWidth: 'thin',
    borderColor: palette.shinyGrey,
    display: 'flex',
  },
  icon: {
    paddingRight: 12,
    width: '30px',
    alignSelf: 'unset',
  },
  splitsContainer: {
    marginBottom: 15,
    marginLeft: 24,
    marginRight: 24,
    backgroundColor: palette.white,
    overflow: 'visible',
  },
  inputLabel: {
    fontSize: fieldFontSize,
    '& label.Mui-focused': {
      color: palette.black,
    },
    '& label': {
      color: palette.black,
    },
    '&::placeholder': {
      color: palette.black,
      opacity: '100%',
    },
  },
  formLabel: {
    height: 20,
    marginLeft: 0,
  },
  checkboxLabel: {
    fontSize: checkBoxFontSize,
    color: palette.slateGrey,
    marginLeft: 5,
  },
  checkbox: {
    fontSize: checkBoxFontSize + 6,
    paddingBottom: 3,
    height: 30,
    marginTop: 10,
  },
  categoryField: {
    fontSize: fieldFontSize,
    '& input': {
      width: '95%',
      paddingBottom: 1,
      '& label.Mui-focused': {
        color: palette.black,
      },
      '& label': {
        color: palette.black,
      },
      '&::placeholder': {
        color: palette.black,
        opacity: '100%',
      },
    },
  },
  categoryFieldSection: {
    background: palette.white,
    color: palette.black,
    fontSize: '15px',
    width: '100% !important',
    display: 'flex',
    height: 56,
    borderBottomStyle: 'solid',
    borderRadius: 0,
    borderBottomWidth: 'thin',
    borderColor: palette.shinyGrey,
  },
  buttonHolder: {
    textAlign: 'right',
    margin: 'auto',
    marginTop: '10px',
    background: palette.white,
    padding: 24,
    paddingTop: 0,
  },
  disclaimer: {
    fontSize: '11px',
    color: palette.slateGrey,
  },
  headerTitle: {
    display: 'flex',
    padding: 24,
    alignItems: 'center',
    backgroundColor: palette.grey.level1,
    justifyContent: 'space-between',
    borderRadius: '8px 8px 0 0',
  },
  closeButtonTop: {
    padding: 0,
  },
});


